import { TimelineOppositeContent } from "@mui/lab"
import { TimelineConnector } from "@mui/lab"
import { TimelineDot } from "@mui/lab"
import { TimelineSeparator } from "@mui/lab"
import { TimelineItem } from "@mui/lab"
import { Timeline } from "@mui/lab"
import CodeIcon from '@mui/icons-material/Code';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import SchoolIcon from '@mui/icons-material/School';
import { TimelineContent } from "@mui/lab"
import { Avatar, Box, Chip, Container, Typography } from "@mui/material"
import { grey, green, yellow } from "@mui/material/colors"

const Experience = () => {
  return(
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: '#efe1bd',
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="lg">
          <Timeline position="alternate" sx={{backgroundColor: '#efe1bd', maxWidth: 700, marginX: 'auto'}}>

            <Typography
                  sx={{ mb: 7 }}
                  variant="h4"
                  align="center"
                  letterSpacing= '6px' 
                  textTransform= 'uppercase'
                >
                  Experience
            </Typography>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                align="right"
                variant="body2"
                color="text.secondary"
              >
                2017 - Present
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot sx={{bgcolor: yellow[400], color: '#424242'}}>
                  <LaptopMacIcon />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <Typography variant="h6" component="span">
                  Fresh Graduate
                </Typography>
                <Typography>Become a freelancer in several semesters, and participate in the Bangkit event 2021 on the Cloud path.</Typography>
                <Box>
                  <Chip sx={{ bgcolor:grey[900], color: grey[50]}} size="small" avatar={<Avatar><i className="devicon-git-plain colored" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="Git" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor:grey[900], color: grey[50]}} size="small" avatar={<Avatar><i className="devicon-javascript-plain colored" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="Javascript" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor:grey[900], color: grey[50]}} size="small" avatar={<Avatar><i className="devicon-mongodb-plain colored" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="MongoDb" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-googlecloud-plain colored" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="Google Cloud" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-laravel-plain colored" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="Laravel" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-express-original" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="Express Js" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-react-plain colored" style={{fontSize: '25px', backgroundColor:'black'}}></i></Avatar>} label="React Js" style={{marginRight: 4, marginBottom: 4}} />


                </Box>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                variant="body2"
                color="text.secondary"
              >
                2014 - 2016
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="primary">
                  <SchoolIcon />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <Typography variant="h6" component="span">
                Vocational High School
                </Typography>
                <Typography>Ever made a simple application for schools such as student data collection.</Typography>
                <Box>
                  <Chip sx={{ bgcolor:grey[900], color: grey[50]}} size="small" avatar={<Avatar><i className="devicon-html5-plain colored" style={{fontSize: '25px', backgroundColor:'white'}}></i></Avatar>} label="HTML" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-css3-plain colored" style={{fontSize: '25px', backgroundColor:'white'}}></i></Avatar>} label="CSS" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-php-plain colored" style={{fontSize: '25px', backgroundColor:'white'}}></i></Avatar>} label="PHP" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-mysql-plain colored" style={{fontSize: '25px', backgroundColor:'white'}}></i></Avatar>} label="MySQL" style={{marginRight: 4, marginBottom: 4}} />

                  <Chip sx={{ bgcolor: grey[900], color: grey[50] }} size="small" avatar={<Avatar><i className="devicon-photoshop-plain colored" style={{fontSize: '25px', backgroundColor:'white'}}></i></Avatar>} label="Photoshop" style={{marginRight: 4, marginBottom: 4}} />

                </Box>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot sx={{bgcolor: green[500]}}>
                  <CodeIcon />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <Typography variant="h6" component="span">
                  Start Journey
                </Typography>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        </Container>
      </Box>
    </>
  )
}

export default Experience